import { render, staticRenderFns } from "./DocumentationList.vue?vue&type=template&id=9c12da8e&scoped=true"
import script from "./DocumentationList.vue?vue&type=script&lang=js"
export * from "./DocumentationList.vue?vue&type=script&lang=js"
import style0 from "./DocumentationList.vue?vue&type=style&index=0&id=9c12da8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c12da8e",
  null
  
)

export default component.exports